import { useId } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/components';

interface Props {
    message: string;
}

export function CancellationUnavailable({ message }: Props) {
    const headingId = useId();

    return (
        <Card ariaLabelledBy={headingId}>
            <CardHeader>
                <CardTitle as="h3" id={headingId}>
                    This agreement cannot be cancelled
                </CardTitle>
            </CardHeader>
            <CardContent>
                <p className="text-sm text-mp-foreground">{message}</p>
            </CardContent>
        </Card>
    );
}
